import xtend from 'xtend';
import Model from 'model-fns';
import Store from 'pull-store';
var model = Model('assetID');
import Ev from '../../lib/event';

function AssetsStore () {
    return xtend(model(), {
        hasFetched: false
    });
}

AssetsStore.update = xtend(model.update, {
    get: function (state, ev) {
        return xtend(model.update.get(state, ev), {
            hasFetched: true
        });
    }
});

AssetsStore.store = Store(function (state, ev) {
    return AssetsStore.update[Ev.type(ev)](state, Ev.data(ev));
}, AssetsStore())

export default AssetsStore;